import { render, staticRenderFns } from "./Kids.vue?vue&type=template&id=2209899e&"
import script from "./Kids.vue?vue&type=script&lang=js&"
export * from "./Kids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports